<div class="dashboard-container">
  <app-dashboard-filtros titulo="Dashboard"></app-dashboard-filtros>
  <!-- Layout responsive: StatCards de Clientes y Gráfico -->
  <div class="resumenes-grafico-container">
    <!-- StatCards de Clientes -->
    <div class="stat-cards-container">
      @if (!esClienteMinorista) {
        @if (statCardClientes) {
          <app-stat-card
            [config]="statCardClientes"
            [formatAsNumber]="true"
            numberFormat="1.0-2"
          ></app-stat-card>
        }
        @if (statCardClientesMayoristas) {
          <app-stat-card
            [config]="statCardClientesMayoristas"
            [formatAsNumber]="true"
            numberFormat="1.0-2"
          ></app-stat-card>
        }
        @if (statCardClientesMinoristas) {
          <app-stat-card
            [config]="statCardClientesMinoristas"
            [formatAsNumber]="true"
            numberFormat="1.0-2"
          ></app-stat-card>
        }
        @if (statCardClientesFinales) {
          <app-stat-card
            [config]="statCardClientesFinales"
            [formatAsNumber]="true"
            numberFormat="1.0-2"
          ></app-stat-card>
        }
      }
    </div>

    <!-- Gráfico de Dispositivos -->
    @if (hayModulosDispositivos) {
      <app-chart-card
        variante="panel"
        [config]="chartCardDispositivosTotal"
        style="width: 100%"
      ></app-chart-card>
    }
  </div>

  <!-- Resumen -->
  <!-- <div style="display: flex; justify-content: space-around"> -->
  <!-- <app-resumenes [resumenes]="resumenes"></app-resumenes> -->
  <!-- </div> -->

  <!-- Navegación de gráficos -->
  <div class="graficos-navegacion">
    @if (hayModulosDispositivos || !esClienteMinorista) {
      <mat-tab-group class="custom-tab-group">
        <!-- Tab: Gráficos Dispositivos -->
        @if (hayModulosDispositivos) {
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">devices</mat-icon>
              <span>Dispositivos</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content-container">
                <!-- Sub-tabs por tipo de dispositivo -->
                <mat-tab-group class="custom-tab-group subtabs">
                  <!-- Sub-tab: Alarmas -->
                  @if (puedeVer.alarmas) {
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">doorbell</mat-icon>
                        <span>Alarmas</span>
                      </ng-template>
                      <ng-template matTabContent>
                        <div class="tab-content-container">
                          <!-- Stat Cards de Alarmas -->
                          <div class="alarmas-stats-grid">
                            @if (statCardAlarmas) {
                              <app-stat-card
                                [config]="statCardAlarmas"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardAlarmasConAlta) {
                              <app-stat-card
                                [config]="statCardAlarmasConAlta"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardAlarmasReportando) {
                              <app-stat-card
                                [config]="statCardAlarmasReportando"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                          </div>

                          <!-- Gráfico de Alarmas por Marca -->
                          <app-chart-card
                            variante="panel"
                            [config]="chartCardAlarmasPorMarca"
                          ></app-chart-card>
                        </div>
                      </ng-template>
                    </mat-tab>
                  }

                  <!-- Sub-tab: Activos -->
                  @if (puedeVer.activos) {
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">
                          assistant_navigation
                        </mat-icon>
                        <span>Activos</span>
                      </ng-template>
                      <ng-template matTabContent>
                        <div class="tab-content-container">
                          <!-- Stat Cards de Activos -->
                          <div class="activos-stats-grid">
                            @if (statCardActivos) {
                              <app-stat-card
                                [config]="statCardActivos"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardActivosReportando) {
                              <app-stat-card
                                [config]="statCardActivosReportando"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                          </div>
                        </div>
                      </ng-template>
                    </mat-tab>
                  }

                  <!-- Sub-tab: Sirenas -->
                  @if (puedeVer.sirenas) {
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">campaign</mat-icon>
                        <span>Sirenas</span>
                      </ng-template>
                      <ng-template matTabContent>
                        <div class="tab-content-container">
                          <!-- Stat Cards de Sirenas -->
                          <div class="alarmas-stats-grid">
                            @if (statCardSirenas) {
                              <app-stat-card
                                [config]="statCardSirenas"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardSirenasOnline) {
                              <app-stat-card
                                [config]="statCardSirenasOnline"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardSirenasOffline) {
                              <app-stat-card
                                [config]="statCardSirenasOffline"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                          </div>
                        </div>
                      </ng-template>
                    </mat-tab>
                  }

                  <!-- Sub-tab: Vehículos -->
                  @if (puedeVer.vehiculos) {
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">directions_car</mat-icon>
                        <span>Vehículos</span>
                      </ng-template>
                      <ng-template matTabContent>
                        <div class="tab-content-container">
                          <!-- Stat Cards de Vehículos -->
                          <div class="vehiculos-stats-grid">
                            @if (statCardVehiculos) {
                              <app-stat-card
                                [config]="statCardVehiculos"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardVehiculosReportando) {
                              <app-stat-card
                                [config]="statCardVehiculosReportando"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardVehiculosEnMovimiento) {
                              <app-stat-card
                                [config]="statCardVehiculosEnMovimiento"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                          </div>

                          <!-- Gráficos de Vehículos -->
                          <div class="vehiculos-charts-grid">
                            <!-- Vehiculos por tipo -->
                            <app-chart-card
                              variante="panel"
                              [config]="chartCardVehiculosPorTipo"
                            ></app-chart-card>

                            <!-- Vehiculos por funcion -->
                            <app-chart-card
                              variante="panel"
                              [config]="chartCardVehiculosPorFuncion"
                            ></app-chart-card>
                          </div>

                          <!-- Gráfico de consumo de combustible -->
                          <app-chart-card
                            variante="panel"
                            [config]="chartCardConsumo"
                          ></app-chart-card>
                        </div>
                      </ng-template>
                    </mat-tab>
                  }

                  <!-- Sub-tab: Colectivos -->
                  @if (puedeVer.colectivos) {
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">directions_bus</mat-icon>
                        <span>Colectivos</span>
                      </ng-template>
                      <ng-template matTabContent>
                        <div class="tab-content-container">
                          <!-- Stat Cards de Colectivos -->
                          <div class="alarmas-stats-grid">
                            @if (statCardColectivos) {
                              <app-stat-card
                                [config]="statCardColectivos"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardColectivosConRecorrido) {
                              <app-stat-card
                                [config]="statCardColectivosConRecorrido"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardColectivosEnMovimiento) {
                              <app-stat-card
                                [config]="statCardColectivosEnMovimiento"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                          </div>
                        </div>
                      </ng-template>
                    </mat-tab>
                  }
                  <!-- Sub-tab: Luminarias -->
                  @if (puedeVer.luminarias) {
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="tab-icon">lightbulb</mat-icon>
                        <span>Luminarias</span>
                      </ng-template>
                      <ng-template matTabContent>
                        <div class="tab-content-container">
                          <!-- Stat Cards de Luminarias -->
                          <div class="activos-stats-grid">
                            @if (statCardLuminarias) {
                              <app-stat-card
                                [config]="statCardLuminarias"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                            @if (statCardLuminariasReportesRecientes) {
                              <app-stat-card
                                [config]="statCardLuminariasReportesRecientes"
                                [formatAsNumber]="true"
                                numberFormat="1.0-0"
                              ></app-stat-card>
                            }
                          </div>
                          <!-- Informe diario -->
                          <app-informe-diario-luminarias></app-informe-diario-luminarias>
                        </div>
                      </ng-template>
                    </mat-tab>
                  }
                </mat-tab-group>
              </div>
            </ng-template>
          </mat-tab>
        }

        <!-- Tab: Gráficos Cliente -->
        @if (!esClienteMinorista) {
          <mat-tab>
            <ng-template mat-tab-label>
              <mat-icon class="tab-icon">account_tree</mat-icon>
              <span>Clientes</span>
            </ng-template>
            <ng-template matTabContent>
              <div class="tab-content-container">
                <!-- Vista de jerarquía -->
                @if (vistaActual === 'jerarquia') {
                  <div class="navegacion-header"></div>
                  <div class="grafico-container">
                    <app-chart-card
                      variante="panel"
                      [config]="chartCardJerarquia"
                      [highchartsOverride]="highchartsPlain"
                    ></app-chart-card>
                    <p class="grafico-help">
                      <mat-icon>info</mat-icon>
                      Hacé clic en un cliente para ver su distribución de
                      dispositivos
                    </p>
                  </div>
                }

                <!-- Vista de dispositivos por cliente -->
                @if (vistaActual === 'dispositivos' && clienteSeleccionado) {
                  <div class="navegacion-header">
                    <button
                      irxBoton="tonal"
                      (click)="volverAJerarquia()"
                      [disabled]="!hayJerarquia"
                    >
                      <mat-icon>arrow_back</mat-icon>
                      Volver a jerarquía
                    </button>
                    <h3>Dispositivos - {{ clienteSeleccionado.nombre }}</h3>
                  </div>
                  <div class="dispositivos-cliente-grid">
                    <!-- Dispositivos cliente -->
                    <app-chart-card
                      variante="panel"
                      [config]="chartCardDispositivosCliente"
                    ></app-chart-card>
                    <!-- Dispositivos cliente (solo propios) -->
                    <app-chart-card
                      variante="panel"
                      [config]="chartCardDispositivosClienteDirecto"
                    ></app-chart-card>
                  </div>
                }
              </div>
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>
    } @else {
      <app-empty-state
        icon="widgets"
        title="No hay módulos habilitados"
        subtitle="Su cuenta no tiene módulos activos para mostrar en el dashboard."
      ></app-empty-state>
    }
  </div>

  <!-- Grid de gráficos ordenables (OCULTO) -->
</div>
